import Call from '../Call';
import {objToQs} from '../Utils';

const AkFull = {
    get(filters) {
        return Call(`akFull?${objToQs(filters)}`);
    },

    getSubid(filters) {
        return Call(`akFull/subid?${objToQs(filters)}`);
    }
};

export default AkFull;


// WEBPACK FOOTER //
// ./src/services/API/components/AkFull.js